export const machineTypes = {
  AWS: 'Compute (EC2)',
  AZURE: 'Compute (Virtual Machines)',
  GCP: 'Compute (GCE Instances)',
  HUAWEI: 'Compute (ECS)',
  OCI: 'Compute (OCI Instances)',
};

export const machineStates = {
  AWS: { on: ['running'], off: ['stopped'] },
  AZURE: { on: ['running'], off: ['stopped', 'deallocated'] },
  GCP: { on: ['running'], off: ['terminated', 'stopped', 'suspended'] },
  HUAWEI: { on: ['active'], off: ['shutoff', 'stopped'] },
  OCI: { on: ['running'], off: ['stopped'] },
};

export function machineStateLabel(provider, state) {
  const states = machineStates[provider?.toUpperCase()];
  if (!state || state === 'unknown') return 'Sin estado informado';
  if (states?.on.includes(state)) return `Encendida (${state})`;
  if (states?.off.includes(state)) return `No encendida (${state})`;
  return state;
}
